// localStorage wrappers that never throw (private mode, blocked storage, quota) so the app
// still works, just without remembering.
export function load<T>(key: string, fallback: T): T {
  try {
    const raw = localStorage.getItem(key);
    return raw == null ? fallback : (JSON.parse(raw) as T);
  } catch {
    return fallback;
  }
}

export function save(key: string, value: unknown): void {
  try {
    localStorage.setItem(key, JSON.stringify(value));
  } catch {
    /* storage unavailable: keep working in memory */
  }
}

export function remove(key: string): void {
  try {
    localStorage.removeItem(key);
  } catch {
    /* ignore */
  }
}

export const KEYS = {
  session: 'er.session',
  script: 'er.script',
  lang: 'er.lang',                // account language (ta | en | tg), mirrored from the server
  me: 'er.me',                    // cached profile
  grocery: 'er.grocery',          // selected reel ids
  groceryChecked: 'er.grocery.checked',
  groceryHidePantry: 'er.grocery.hidePantry',
  inHand: (id: number) => `er.inhand.${id}`, // ingredient ticks per recipe
  installDismissed: 'er.install.dismissed', // when "Not now" was tapped on the install popup (ms)
};
